import { render, staticRenderFns } from "./IprelayFooter.vue?vue&type=template&id=6d48dbae&scoped=true"
import script from "./IprelayFooter.vue?vue&type=script&lang=js"
export * from "./IprelayFooter.vue?vue&type=script&lang=js"
import style0 from "./IprelayFooter.vue?vue&type=style&index=0&id=6d48dbae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d48dbae",
  null
  
)

export default component.exports